export function isClickOutside(element, event) {
    if (!element)
        return true;
    return !event.composedPath().includes(element);
}
